export default function SearchInput({ ...props }) {
  return (
    <div className="">
      <label className="relative block">
        <span className="sr-only">Search</span>
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <svg
            width="14"
            height="14"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.21879 9.21873L6.64941 6.64935"
              stroke="#848484"
              strokeMiterlimit="10"
              strokeMiterLimit="square"
            />
            <path
              d="M4.21875 7.65625C6.11723 7.65625 7.65625 6.11723 7.65625 4.21875C7.65625 2.32027 6.11723 0.78125 4.21875 0.78125C2.32027 0.78125 0.78125 2.32027 0.78125 4.21875C0.78125 6.11723 2.32027 7.65625 4.21875 7.65625Z"
              stroke="#848484"
              strokeMiterlimit="10"
              strokeMiterLimit="square"
            />
          </svg>
        </span>
        <input
          type="text"
          placeholder="Search"
          className="py-1.5 pl-8 border-none focus:border-none focus:pr-10 focus:outline-none rounded-md bg-[#F4F4F4] "
          {...props}
        />
      </label>
    </div>
  );
}
